import type {
  BlockClinicsLocation,
  Clinics,
} from 'types/block-clinics-location';
import React from 'react';
import Image from 'next/image';
import { Link, Paragraph, Wrap } from '@leafwell/components';
import LocationBusinessJson from 'components/structured-data/location-business';
import HeadingBody from './heading-body';

const Clinic: React.FC<Clinics> = clinics => {
  const clinic = clinics.clinic[0];
  const encodedAddress = encodeURIComponent(clinic.streetAddress);
  const placeId = clinic.placeId;

  return (
    <div className="grid gap-2 w-full md:w-88 p-4 border border-lilac-300 rounded-2xl">
      <Link
        href={clinics?.url || '#'}
        target="_blank"
        rel="noopener noreferrer"
        className="text-base lg:text-lg font-semibold text-lilac-500 mb-2 hover:text-lilac-400 transition-colors duration-200 hover:underline"
      >
        {clinic.name.replace('- Medical Cannabis Clinic ', '')}
      </Link>
      <Paragraph tagName="p" variant="medium" size="xsmall">
        {clinic.streetAddress}
        <br />
        {clinic.postalCode}, {clinic.addressLocality}
      </Paragraph>
      <Paragraph
        tagName="p"
        size="xsmall"
        className="font-medium text-green-600"
      >
        {clinics.openingHours}
      </Paragraph>
      <Link
        className="font-medium flex gap-3 items-center justify-between group mt-2 border border-green-600 rounded-2xl p-2 px-4"
        href={`https://www.google.com/maps/search/?api=1&query=${encodedAddress}&query_place_id=${placeId}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <span>Get directions</span>
        <Image
          src="/directions.svg"
          alt=""
          width={17}
          height={18}
          className="w-5 transition-opacity group-hover:opacity-50"
        />
      </Link>
    </div>
  );
};

const ClinicsLocation: React.FC<BlockClinicsLocation> = ({
  sectionId,
  instanceId,
  title,
  description,
  clinics,
}) => {
  const clinicsData = clinics
    .map(entry => entry.clinic[0])
    .filter((c): c is Clinics['clinic'][0] => c != null);

  return (
    <>
      <Wrap id={sectionId} itemID={`ClinicsLocation-${instanceId}`}>
        {title || description ? (
          <div className="grid gap-y-6 justify-items-center">
            {title && (
              <HeadingBody
                level="2"
                tagName="h2"
                title={title}
                className="font-semibold text-center"
              />
            )}
            {description && (
              <Paragraph
                dangerouslySetInnerHTML={{ __html: description }}
                size="large"
                className="text-center lg:max-w-5xl"
              />
            )}
          </div>
        ) : null}
        {clinics.length > 0 ? (
          <div className="flex flex-wrap gap-6 md:max-w-6xl md:mx-auto">
            {clinics.map(clinics => (
              <Clinic key={clinics.clinic[0].name} {...clinics} />
            ))}
          </div>
        ) : null}
      </Wrap>
      {/*       <LocationBusinessJson partners={clinicsData} /> */}
    </>
  );
};

export default ClinicsLocation;
